import React from "react";

const TrainingHero: React.FC = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center px-3 w-full">
        <div className="text-center text-white text-2xl md:text-3xl pt-5 w-full max-w-4xl lg:text-4xl font-light xl:text-[3.4rem] xl:space-y-7">
          <h3 className="">Dream Weavers Professional</h3>
          <h3>Corporate Training Ground</h3>
        </div>
        <p className="pt-4 xl:pt-8 text-sm xl:text-[1.65rem] text-center max-w-4xl font-light text-[#FF7E00]">
          Training That Transforms Careers and Organizations
        </p>
        <p className="pt-4 xl:pt-8 text-sm xl:text-base text-center max-w-3xl font-light text-white">
          Unlock the potential of your workforce with industry-leading corporate
          training programs trusted by top companies across India.
        </p>
      </div>
      <div className="flex justify-center items-center pt-[5rem] xl:pt-[5.5rem] -mb-[8rem] md:pt-10 md:-mb-[13rem] xl:-mb-[20rem]">
        <div className="max-w-lg md:max-w-2xl h-[12rem] sm:h-[19rem] rounded-xl lg:rounded-3xl md:w-[34rem] lg:h-[28rem] sm:w-[29rem] lg:max-w-4xl xl:h-[32rem] lg:w-[90rem]">
          <img src="/training/hero.png" alt="" className="w-full h-full" />
        </div>
      </div>
    </div>
  );
};

export default TrainingHero;
